export default __webpack_public_path__ + "static/media/formulario-imagem.84e18c7c.svg";